import { useEffect } from 'react';
import { ElementUpdateTypes } from '@bynder-studio/render-core';
import useForceUpdate from 'packages/hooks/useForceUpdate';
import useEditor from 'packages/hooks/useEditor';
import useEditorSelectedElement from 'packages/hooks/useEditorSelectedElement';

const useMaskApply = () => {
    const forceUpdate = useForceUpdate();
    const { creativeModel } = useEditor();
    const { selectedElement } = useEditorSelectedElement();

    useEffect(() => {
        return () => {
            creativeModel.onElementPartialUpdate(selectedElement.id, ElementUpdateTypes.MASK, forceUpdate);
            creativeModel.onElementPartialUpdate(selectedElement.id, ElementUpdateTypes.SHAPE, forceUpdate);
        };
    }, [selectedElement.id, creativeModel]);
};

export default useMaskApply;
